const BASE_URL = 'v1/tracking-analytics';

export const VISITED_AFTER_PAYING_URL = `${BASE_URL}/visited-after-paying`;
export const QUALITY_LEAD_NOTIFY_URL = `${BASE_URL}/quality-lead-notify`;
